import { TaskCenterData, BadgeVariant } from "../../types";

export const taskCenterData: any = {
  stats: {
    active_count: 6,
    in_progress_count: 3,
    resolved_count: 200,
    dismiss_count: 2,
    unaddressed_count: 5,
    total_count: 23
  },
  filters: {
    timeRange: "0",
    branch: "all",
    rankBy: "escalation_time",
    escalationTime: "Escalation time",
    showAtRisk: false,
    showInProgress: false,
    showResolved: false,
    showDismissed: false,
    showExpired: false
  },
  rows: [
    {
      id: "1",
      priority: {
        type: "overdue",
        icon: "FeatherAlertTriangle",
        label: "Overdue",
        color: "text-error-700"
      },
      status: {
        variant: BadgeVariant.ERROR,
        score: "Action needed"
      },
      employee: {
        name: "Jason Yu",
        jobTitle: "Nurse",
        location: "Knoxville",
        locationIcon: "FeatherMeh",
        locationColor: "text-warning-800",
        region: "Appalachia"
      },
      tenure: "150d -180d",
      escalationReason: {
        variant: BadgeVariant.INFO,
        score: "Flagged question"
      },
      assignee: {
        name: "Kavein J",
        icon: "FeatherMeh",
        color: "text-warning-800"
      },
      escalationTime: "2 days ago"
    },
    {
      id: "2",
      status: {
        variant: BadgeVariant.WARNING,
        score: "Action needed"
      },
      employee: {
        name: "Jason Yu",
        jobTitle: "Nurse",
        location: "Knoxville",
        locationIcon: "FeatherMeh",
        locationColor: "text-warning-800",
        region: "Appalachia"
      },
      tenure: "150d -180d",
      escalationReason: {
        variant: BadgeVariant.INFO,
        score: "Heavy workload"
      },
      assignee: {
        name: "Kavein J",
        icon: "FeatherMeh",
        color: "text-warning-800"
      },
      escalationTime: "2 days ago"
    },
    {
      id: "3",
      priority: {
        type: "reminder",
        icon: "FeatherCalendar",
        label: "Reminder",
        color: "text-warning-700"
      },
      status: {
        variant: BadgeVariant.WARNING,
        score: "Action needed"
      },
      employee: {
        name: "Khloe Cohen",
        jobTitle: "Nurse",
        location: "Knoxville",
        locationIcon: "FeatherMeh",
        locationColor: "text-warning-800",
        region: "Appalachia"
      },
      tenure: "150d -180d",
      escalationReason: {
        variant: BadgeVariant.INFO,
        score: "Reminder"
      },
      assignee: {
        name: "Kavein J",
        icon: "FeatherMeh",
        color: "text-warning-800"
      },
      escalationTime: "3 days ago"
    },
    {
      id: "4",
      status: {
        variant: BadgeVariant.SUCCESS,
        score: "Resolved"
      },
      employee: {
        name: "Leila Willis",
        jobTitle: "Nurse",
        location: "Asheville",
        locationIcon: "FeatherSmile",
        locationColor: "text-success-800",
        region: "Appalachia"
      },
      tenure: "10d -30d",
      escalationReason: {
        variant: BadgeVariant.INFO,
        score: "Low sentiment"
      },
      assignee: {
        name: "Kavein J",
        icon: "FeatherMeh",
        color: "text-warning-800"
      },
      escalationTime: "3 days ago"
    },
    {
      id: "5",
      status: {
        variant: BadgeVariant.INFO,
        score: "In-progress"
      },
      employee: {
        name: "Marilyn Peters",
        jobTitle: "Nurse",
        location: "Asheville",
        locationIcon: "FeatherSmile",
        locationColor: "text-success-800",
        region: "Appalachia"
      },
      tenure: "2yr-3yr",
      escalationReason: {
        variant: BadgeVariant.INFO,
        score: "Low sentiment"
      },
      assignee: {
        name: "Kavein J",
        icon: "FeatherMeh",
        color: "text-warning-800"
      },
      escalationTime: "27 days ago"
    },
    {
      id: "6",
      status: {
        variant: BadgeVariant.INFO,
        score: "Dismissed"
      },
      employee: {
        name: "Marilyn Peters",
        jobTitle: "Nurse",
        location: "Asheville",
        locationIcon: "FeatherSmile",
        locationColor: "text-success-800",
        region: "Appalachia"
      },
      tenure: "2yr-3yr",
      escalationReason: {
        variant: BadgeVariant.INFO,
        score: "Low sentiment"
      },
      assignee: {
        name: "Kavein J",
        icon: "FeatherMeh",
        color: "text-warning-800"
      },
      escalationTime: "27 days ago"
    },
    {
      id: "7",
      status: {
        variant: BadgeVariant.INFO,
        score: "Expired"
      },
      employee: {
        name: "Marilyn Peters",
        jobTitle: "Nurse",
        location: "Asheville",
        locationIcon: "FeatherSmile",
        locationColor: "text-success-800",
        region: "Appalachia"
      },
      tenure: "2yr-3yr",
      escalationReason: {
        variant: BadgeVariant.INFO,
        score: "Low sentiment"
      },
      assignee: {
        name: "Kavein J",
        icon: "FeatherMeh",
        color: "text-warning-800"
      },
      escalationTime: "27 days ago"
    }
  ]
}; 